module.exports = __webpack_public_path__ + "static/media/stop_new.8058a24c.svg";